/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * IntakeApp
 * OpenAPI spec version: v1
 */

export type RtmPCCItemKind = typeof RtmPCCItemKind[keyof typeof RtmPCCItemKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RtmPCCItemKind = {
  Enrollment: 'Enrollment',
  CheckIn: 'CheckIn',
} as const;
